/* tslint:disable */
/* eslint-disable */
/**
 * MinSide.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GivenRoleDto } from './GivenRoleDto';
import {
    GivenRoleDtoFromJSON,
    GivenRoleDtoFromJSONTyped,
    GivenRoleDtoToJSON,
    GivenRoleDtoToJSONTyped,
} from './GivenRoleDto';

/**
 * 
 * @export
 * @interface EndUserRequest
 */
export interface EndUserRequest {
    /**
     * 
     * @type {string}
     * @memberof EndUserRequest
     */
    applicationId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EndUserRequest
     */
    firstName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EndUserRequest
     */
    lastName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EndUserRequest
     */
    email: string | null;
    /**
     * 
     * @type {string}
     * @memberof EndUserRequest
     */
    phoneNumber?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EndUserRequest
     */
    externalApplicationUserId?: string | null;
    /**
     * 
     * @type {GivenRoleDto}
     * @memberof EndUserRequest
     */
    givenRole?: GivenRoleDto;
}

/**
 * Check if a given object implements the EndUserRequest interface.
 */
export function instanceOfEndUserRequest(value: object): value is EndUserRequest {
    if (!('email' in value) || value['email'] === undefined) return false;
    return true;
}

export function EndUserRequestFromJSON(json: any): EndUserRequest {
    return EndUserRequestFromJSONTyped(json, false);
}

export function EndUserRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): EndUserRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'applicationId': json['applicationId'] === undefined ? undefined : json['applicationId'] === null ? null : json['applicationId'],
        'firstName': json['firstName'] === undefined ? undefined : json['firstName'] === null ? null : json['firstName'],
        'lastName': json['lastName'] === undefined ? undefined : json['lastName'] === null ? null : json['lastName'],
        'email': json['email'],
        'phoneNumber': json['phoneNumber'] === undefined ? undefined : json['phoneNumber'] === null ? null : json['phoneNumber'],
        'externalApplicationUserId': json['externalApplicationUserId'] === undefined ? undefined : json['externalApplicationUserId'] === null ? null : json['externalApplicationUserId'],
        'givenRole': json['givenRole'] == null ? undefined : GivenRoleDtoFromJSON(json['givenRole']),
    };
}

export function EndUserRequestToJSON(json: any): EndUserRequest {
    return EndUserRequestToJSONTyped(json, false);
}

export function EndUserRequestToJSONTyped(value?: EndUserRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'applicationId': value['applicationId'],
        'firstName': value['firstName'],
        'lastName': value['lastName'],
        'email': value['email'],
        'phoneNumber': value['phoneNumber'],
        'externalApplicationUserId': value['externalApplicationUserId'],
        'givenRole': GivenRoleDtoToJSON(value['givenRole']),
    };
}

